export default __webpack_public_path__ + "static/media/down-chevron-green.49c12512.svg";